<template>
  <div>
    <div class="overlay-div" v-on:click.stop="handleNegativeAnswer"></div>
    <queue-list
      :allowSelection="queuePopUp.allowSelection"
      @elementSelected="handleElementSelection"
      class="queue-pop-up background-color"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "QueuePopUp",
  data() {
    return {};
  },
  created: function () {
    this.setSelectedPreFilters(this.queuePopUp.preFilters);
    this.setSelectedFilter(undefined);
    window.addEventListener(
      "keyup",
      function (e) {
        if (this.isBlurred) {
          return;
        }
        if (e.keyCode === 27) {
          this.handleNegativeAnswer();
        }
      }.bind(this)
    );
  },
  destroyed: function () {
    this.setSelectedPreFilters(undefined);
    this.setSelectedFilter(undefined);
  },
  computed: {
    ...mapGetters({
      queuePopUp: "queueModule/queuePopUp",
    }),
  },
  methods: {
    ...mapActions({
      setQueuePopUp: "queueModule/setQueuePopUp",
      setSelectedPreFilters: "queueModule/setSelectedPreFilters",
      setSelectedFilter: "queueModule/setSelectedFilter",
    }),
    handleNegativeAnswer: function () {
      if (this.queuePopUp.negativeCallback) {
        this.queuePopUp.negativeCallback();
      }
      this.setQueuePopUp({ isOpen: false });
    },
    handleElementSelection(selectedElement) {
      if (this.queuePopUp.positiveCallback) {
        this.queuePopUp.positiveCallback({ selectedElement: selectedElement });
        this.setQueuePopUp({ isOpen: false });
      }
    },
  },
};
</script>

<style lang="scss">
.queue-pop-up {
  border-radius: $border-radius-0;
  position: fixed;
  width: 80%;
  height: 80%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  // background-color: $dark-background-color;
  overflow-y: auto;
}
</style>
